/*
 * Troca imagens do carrossel da página de produto conforme a variante (cor).
 * Só substitui as posições configuradas em snippets/homelya-variant-gallery.liquid;
 * as demais posições continuam com as imagens originais do produto.
 * Atua no slider principal, nas miniaturas e no zoom (lightbox).
 */
(function () {
  var cfg = window.homelyaVariantGallery;
  if (!cfg || !cfg.overrides) return;

  function handleize(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  // Descobre qual chave da configuração corresponde às opções da variante selecionada
  function findKey(options) {
    for (var i = 0; i < (options || []).length; i++) {
      var k = handleize(options[i]);
      if (cfg.overrides[k]) return k;
    }
    return null;
  }

  function sized(url, w) {
    try {
      var u = new URL(url, location.origin);
      u.searchParams.set('width', w);
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function setImg(img, url, widths) {
    if (!img) return;
    if (!img.dataset.hvgSaved) {
      img.dataset.hvgSaved = '1';
      img.dataset.hvgSrc = img.getAttribute('src') || '';
      img.dataset.hvgSrcset = img.getAttribute('srcset') || '';
    }
    if (url) {
      var largest = widths[widths.length - 1];
      if (widths.length > 1) {
        img.setAttribute(
          'srcset',
          widths.map(function (w) { return sized(url, w) + ' ' + w + 'w'; }).join(', ')
        );
      } else {
        img.removeAttribute('srcset');
      }
      img.setAttribute('src', sized(url, largest));
    } else {
      img.setAttribute('src', img.dataset.hvgSrc);
      if (img.dataset.hvgSrcset) img.setAttribute('srcset', img.dataset.hvgSrcset);
      else img.removeAttribute('srcset');
    }
  }

  function apply(key) {
    var map = (key && cfg.overrides[key]) || {};
    var slides = document.querySelectorAll('media-gallery [id^="Slider-Gallery"] > li[data-media-id]');
    Array.prototype.forEach.call(slides, function (li, i) {
      var pos = i + 1; // posição exibida no carrossel (1 = primeira)
      var url = map[pos] || null;
      var mediaId = li.dataset.mediaId;
      var rawId = mediaId.split('-').pop();

      // slide principal
      setImg(li.querySelector('.product__media img'), url, [550, 1100, 1445]);

      // miniatura
      var thumb = document.querySelector(
        'media-gallery [id^="Slider-Thumbnails"] li[data-target="' + mediaId + '"] img'
      );
      setImg(thumb, url, [240]);

      // zoom (lightbox)
      var modalImg = document.querySelector('.product-media-modal__content img[data-media-id="' + rawId + '"]');
      setImg(modalImg, url, [1100, 1445]);
    });
  }

  function init() {
    apply(findKey(cfg.current));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      // roda depois que o tema atualizou a galeria para a nova variante
      subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        var variant = evt && evt.data && evt.data.variant;
        apply(findKey(variant && variant.options));
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
